import { Shirt, X } from 'lucide-react'
import { useState } from 'react'

// Type definition for attire photos
interface AttirePhoto {
  id: number
  fileId: string
  src: string
  srcFallback: string
  alt: string
  category: string
  aspectRatio: null
}

// Helper function to convert Google Drive file ID to direct image URL
const getGoogleDriveImageUrl = (fileId: string) => {
  return `https://drive.google.com/uc?export=view&id=${fileId}`
}

// Alternative thumbnail URL (sometimes works better)
const getGoogleDriveThumbnailUrl = (fileId: string, size: number = 800) => {
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w${size}`
}

// Attire inspiration photos for each event
const attirePhotos: Record<number, AttirePhoto[]> = {
  1: [], // Welcome Toast - empty for now
  2: [ // Wedding Ceremony & Reception
    {
      id: 1,
      fileId: '16_CEqIgMq4P3Kmy-fAJFBLiF9_waoJbS',
      src: getGoogleDriveThumbnailUrl('16_CEqIgMq4P3Kmy-fAJFBLiF9_waoJbS'),
      srcFallback: getGoogleDriveImageUrl('16_CEqIgMq4P3Kmy-fAJFBLiF9_waoJbS'),
      alt: 'Garden party formal inspiration 1',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 2,
      fileId: '1Rz_m13d8Tfc_HPKSgpZ9-EtXjH5YVsdM',
      src: getGoogleDriveThumbnailUrl('1Rz_m13d8Tfc_HPKSgpZ9-EtXjH5YVsdM'),
      srcFallback: getGoogleDriveImageUrl('1Rz_m13d8Tfc_HPKSgpZ9-EtXjH5YVsdM'),
      alt: 'Garden party formal inspiration 2',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 3,
      fileId: '18bL9oIwENgrnjSq_G-J-UjrJOpwDA-GG',
      src: getGoogleDriveThumbnailUrl('18bL9oIwENgrnjSq_G-J-UjrJOpwDA-GG'),
      srcFallback: getGoogleDriveImageUrl('18bL9oIwENgrnjSq_G-J-UjrJOpwDA-GG'),
      alt: 'Garden party formal inspiration 3',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 4,
      fileId: '1nuyKDcZ-AlFNa5a_qwSgTvbhuuDqfaSY',
      src: getGoogleDriveThumbnailUrl('1nuyKDcZ-AlFNa5a_qwSgTvbhuuDqfaSY'),
      srcFallback: getGoogleDriveImageUrl('1nuyKDcZ-AlFNa5a_qwSgTvbhuuDqfaSY'),
      alt: 'Garden party formal inspiration 4',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 5,
      fileId: '1CVhKK7VYq2A4bcE-tI3cDS_eymzWQDMb',
      src: getGoogleDriveThumbnailUrl('1CVhKK7VYq2A4bcE-tI3cDS_eymzWQDMb'),
      srcFallback: getGoogleDriveImageUrl('1CVhKK7VYq2A4bcE-tI3cDS_eymzWQDMb'),
      alt: 'Garden party formal inspiration 5',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 6,
      fileId: '1ynuxSBDpoVCDD4DIbXVPw87xe-yd0oUR',
      src: getGoogleDriveThumbnailUrl('1ynuxSBDpoVCDD4DIbXVPw87xe-yd0oUR'),
      srcFallback: getGoogleDriveImageUrl('1ynuxSBDpoVCDD4DIbXVPw87xe-yd0oUR'),
      alt: 'Garden party formal inspiration 6',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 7,
      fileId: '1lEQct_U5StVASHVuZrN0ellus62I-hJX',
      src: getGoogleDriveThumbnailUrl('1lEQct_U5StVASHVuZrN0ellus62I-hJX'),
      srcFallback: getGoogleDriveImageUrl('1lEQct_U5StVASHVuZrN0ellus62I-hJX'),
      alt: 'Garden party formal inspiration 7',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 8,
      fileId: '17x1GD7PyDdLLauh4WpFcRblicGtiPEj2',
      src: getGoogleDriveThumbnailUrl('17x1GD7PyDdLLauh4WpFcRblicGtiPEj2'),
      srcFallback: getGoogleDriveImageUrl('17x1GD7PyDdLLauh4WpFcRblicGtiPEj2'),
      alt: 'Garden party formal inspiration 8',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 9,
      fileId: '1jqDOM_zbogKY4Z3Q2WOlUJLJgldKnji7',
      src: getGoogleDriveThumbnailUrl('1jqDOM_zbogKY4Z3Q2WOlUJLJgldKnji7'),
      srcFallback: getGoogleDriveImageUrl('1jqDOM_zbogKY4Z3Q2WOlUJLJgldKnji7'),
      alt: 'Garden party formal inspiration 9',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 10,
      fileId: '17ME4dcBxHOzZY06fsHZJKh39bDMnNu8Y',
      src: getGoogleDriveThumbnailUrl('17ME4dcBxHOzZY06fsHZJKh39bDMnNu8Y'),
      srcFallback: getGoogleDriveImageUrl('17ME4dcBxHOzZY06fsHZJKh39bDMnNu8Y'),
      alt: 'Garden party formal inspiration 10',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 11,
      fileId: '1lcJ0C2F2_2l2kRU4Hp1o8_ezUmpfimzZ',
      src: getGoogleDriveThumbnailUrl('1lcJ0C2F2_2l2kRU4Hp1o8_ezUmpfimzZ'),
      srcFallback: getGoogleDriveImageUrl('1lcJ0C2F2_2l2kRU4Hp1o8_ezUmpfimzZ'),
      alt: 'Garden party formal inspiration 11',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 12,
      fileId: '1UUs9jFJooUV0SaWC7e0GT1vCzB_lXDZa',
      src: getGoogleDriveThumbnailUrl('1UUs9jFJooUV0SaWC7e0GT1vCzB_lXDZa'),
      srcFallback: getGoogleDriveImageUrl('1UUs9jFJooUV0SaWC7e0GT1vCzB_lXDZa'),
      alt: 'Garden party formal inspiration 12',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 13,
      fileId: '1RdTbrPYOscq9KNJB4mYeU4AYAW-rAEGE',
      src: getGoogleDriveThumbnailUrl('1RdTbrPYOscq9KNJB4mYeU4AYAW-rAEGE'),
      srcFallback: getGoogleDriveImageUrl('1RdTbrPYOscq9KNJB4mYeU4AYAW-rAEGE'),
      alt: 'Garden party formal inspiration 13',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 14,
      fileId: '1tiu7RN6zQ5c_Iy2UtX6tGHjCrjq6LMHR',
      src: getGoogleDriveThumbnailUrl('1tiu7RN6zQ5c_Iy2UtX6tGHjCrjq6LMHR'),
      srcFallback: getGoogleDriveImageUrl('1tiu7RN6zQ5c_Iy2UtX6tGHjCrjq6LMHR'),
      alt: 'Garden party formal inspiration 14',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 15,
      fileId: '1A1MK1b7uiDqu9AE0n0OTTAEgRgNZRxD5',
      src: getGoogleDriveThumbnailUrl('1A1MK1b7uiDqu9AE0n0OTTAEgRgNZRxD5'),
      srcFallback: getGoogleDriveImageUrl('1A1MK1b7uiDqu9AE0n0OTTAEgRgNZRxD5'),
      alt: 'Garden party formal inspiration 15',
      category: 'wedding-ceremony',
      aspectRatio: null
    },
    {
      id: 16,
      fileId: '1wGvBoJbtXeKIr7UwcHs5-c9bOmKQZ_FM',
      src: getGoogleDriveThumbnailUrl('1wGvBoJbtXeKIr7UwcHs5-c9bOmKQZ_FM'),
      srcFallback: getGoogleDriveImageUrl('1wGvBoJbtXeKIr7UwcHs5-c9bOmKQZ_FM'),
      alt: 'Garden party formal inspiration 16',
      category: 'wedding-ceremony',
      aspectRatio: null
    }
    // Add more photos here as needed
  ]
}

interface AttireGuideline {
  id: number
  event: string
  dresscode: string
  description: string | JSX.Element
  photos: AttirePhoto[]
}

const attireGuidelines: AttireGuideline[] = [
  {
    id: 1,
    event: 'Welcome Toast (Day before wedding)',
    dresscode: 'Cocktail Casual',
    description: 'Think chic short dresses for the ladies and dress pants with button shirts for the gentlemen. No need for full formalwear — just polished, comfortable, and festive.',
    photos: attirePhotos[1] || []
  },
  {
    id: 2,
    event: 'Wedding Ceremony & Reception',
    dresscode: 'Garden Party Formal',
    description: (
      <>
        Think elevated elegance with a splash of color! Please join us in <strong>formal attire</strong> with a colorful, garden party twist. Suits and long dresses or elevated cocktail dresses are encouraged. Feel free to play with vibrant colors, florals, and elegant patterns. Think classic silhouettes with a bit of personality. This is your chance to be polished and festive while embracing the joyful, outdoor setting.
      </>
    ),
    photos: attirePhotos[2] || []
  },
]

export function Attire() {
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set())
  const [imageErrors, setImageErrors] = useState<Set<string>>(new Set())
  const [imageDimensions, setImageDimensions] = useState<Record<string, { width: number; height: number; aspectRatio: number }>>({})

  const handleImageLoad = (photoKey: string, img: HTMLImageElement) => {
    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
      const aspectRatio = img.naturalWidth / img.naturalHeight
      setImageDimensions(prev => ({
        ...prev,
        [photoKey]: {
          width: img.naturalWidth,
          height: img.naturalHeight,
          aspectRatio
        }
      }))
    }
    setLoadedImages(prev => new Set(prev).add(photoKey))
  }

  const handleImageError = (photoKey: string, img?: HTMLImageElement) => {
    const [guidelineId, photoId] = photoKey.split('-').map(Number)
    const photo = attirePhotos[guidelineId]?.find((p: AttirePhoto) => p.id === photoId)
    
    if (photo && 'srcFallback' in photo && img && !img.src.includes('uc?export=view')) {
      img.src = photo.srcFallback as string
      return
    }
    
    setImageErrors(prev => new Set(prev).add(photoKey))
    setLoadedImages(prev => new Set(prev).add(photoKey))
  }

  const getPhotoHeight = (photoKey: string, baseWidth: number = 250) => {
    const dimensions = imageDimensions[photoKey]
    
    if (dimensions && dimensions.aspectRatio > 0) {
      const calculatedHeight = baseWidth / dimensions.aspectRatio
      return Math.max(180, Math.min(400, calculatedHeight))
    }
    
    const fallbackHeights = [220, 280, 240, 300, 260, 320]
    const hash = photoKey.split('').reduce((a, b) => a + b.charCodeAt(0), 0)
    return fallbackHeights[hash % fallbackHeights.length]
  }



  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="section-padding">
        <div className="container-max">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-serif text-primary-900 mb-4">
              Attire
            </h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Here's what to wear for each event during our wedding weekend.
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-8">
            {attireGuidelines.map((guideline) => (
              <div key={guideline.id} className="bg-white rounded-lg p-8 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <Shirt className="h-5 w-5 text-primary-600" />
                  <h3 className="text-xl font-serif text-primary-900">
                    {guideline.event}
                  </h3>
                </div>
                
                <div className="mb-3">
                  <span className="inline-block bg-primary-100 text-primary-700 px-3 py-1 rounded-full text-sm font-medium">
                    {guideline.dresscode}
                  </span>
                </div>
                
                <p className="text-neutral-600 mb-6">
                  {guideline.description}
                </p>

                {/* Attire Inspiration Photos */}
                {guideline.photos && guideline.photos.length > 0 && (
                  <div className="mt-8">
                    {/* Mini Masonry Gallery */}
                    <div className="columns-1 md:columns-2 lg:columns-3 gap-4">
                      {guideline.photos.map((photo) => {
                        const photoKey = `${guideline.id}-${photo.id}`
                        const photoHeight = getPhotoHeight(photoKey, 250)
                        
                        return (
                          <div
                            key={photo.id}
                            className="relative overflow-hidden rounded-2xl shadow-lg break-inside-avoid mb-4"
                            style={{ 
                              height: `${photoHeight}px`,
                              transition: 'height 0.3s ease-out'
                            }}
                          >
                            {/* Loading skeleton */}
                            {!loadedImages.has(photoKey) && !imageErrors.has(photoKey) && (
                              <div className="absolute inset-0 bg-gradient-to-r from-neutral-200 via-neutral-300 to-neutral-200">
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <div className="w-8 h-8 border-4 border-primary-300 border-t-primary-600 rounded-full animate-spin" />
                                </div>
                              </div>
                            )}

                            {/* Error state */}
                            {imageErrors.has(photoKey) && (
                              <div className="absolute inset-0 bg-gradient-to-br from-neutral-100 to-neutral-200 flex items-center justify-center rounded-2xl">
                                <div className="text-center text-neutral-500 p-4">
                                  <div className="w-12 h-12 bg-neutral-300 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <X className="w-6 h-6" />
                                  </div>
                                  <p className="text-xs font-medium">Image unavailable</p>
                                </div>
                              </div>
                            )}

                            {/* Main image */}
                            <img
                              src={photo.src}
                              alt={photo.alt}
                              className={`w-full h-full object-cover ${
                                loadedImages.has(photoKey) && !imageErrors.has(photoKey) ? 'opacity-100' : 'opacity-0'
                              }`}
                              onLoad={(e) => handleImageLoad(photoKey, e.target as HTMLImageElement)}
                              onError={(e) => handleImageError(photoKey, e.target as HTMLImageElement)}
                              loading="lazy"
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-16 max-w-2xl mx-auto">
            <div className="bg-white rounded-lg p-8 shadow-sm text-center">
              <h3 className="text-2xl font-serif text-primary-900 mb-4">
                Weather in Oaxaca
              </h3>
              <p className="text-neutral-600 mb-2">
                <strong>April Temperature:</strong> 75-85°F (24-29°C)
              </p>
              <p className="text-neutral-600">
                Expect warm, sunny days perfect for outdoor celebrations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 